"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _listItem = _interopRequireDefault(require("./list-item"));
/**
 * Local Imports
 */

const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hu0kk48"
});
const ListContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "ListContainer",
  class: "pl-la8w7sx"
});

/**
 * GroupList Component.
 *
 * @param {Object} props React props
 * @param {String} props.categoryLabel Label of the list section
 * @param {String} props.categoryDescription Description of the list section
 * @param {Array} props.list List of Items
 * @param {String} props.heading Heading of GroupList Item
 * @param {String} props.description Description of GroupList Item
 * @param {String} props.headlineSize Accessible heading props
 * @param {String} props.headlineTag Accessible heading props
 * @param {String} props.partial Theme partials
 * @returns {React.ReactElement} GroupList Component
 * @public
 */

function GroupList({
  categoryLabel,
  categoryDescription,
  list,
  inverted = false,
  partial,
  headlineSize,
  headlineTag
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: categoryLabel,
    description: categoryDescription,
    headlineSize: headlineSize ?? 'h5',
    headlineTag: headlineTag ?? 'h2',
    textAlign: "start"
  })), /*#__PURE__*/_react.default.createElement(ListContainer, {
    "data-cy": "list-container"
  }, list?.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_listItem.default, (0, _extends2.default)({
      key: idx
    }, item, {
      partial: partial || (inverted ? 'dark1' : '')
    }));
  })));
}
var _default = exports.default = GroupList;
GroupList.propTypes = {
  categoryLabel: _propTypes.default.string,
  categoryDescription: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape(_listItem.default.propTypes)),
  partial: _propTypes.default.string,
  inverted: _propTypes.default.bool,
  headlineSize: _propTypes.default.string,
  headlineTag: _propTypes.default.string
};